/**
 * Dynamic Google Maps loader — loads the Maps JS API from an env var
 * instead of a hardcoded key in index.html.
 */
let loadPromise = null;

export function loadGoogleMaps() {
  if (loadPromise) return loadPromise;

  // Already loaded (e.g. cached from a previous session)
  if (window.google && window.google.maps) {
    return Promise.resolve();
  }

  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  if (!apiKey) {
    console.warn('[loadGoogleMaps] REACT_APP_GOOGLE_MAPS_API_KEY not set — Places autocomplete will use fallback');
    return Promise.resolve();
  }

  loadPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
    script.async = true;
    script.defer = true;
    script.onload = resolve;
    script.onerror = () => reject(new Error('Failed to load Google Maps API'));
    document.head.appendChild(script);
  });

  return loadPromise;
}
